import { injectInvoiceV1Api } from '@delmonicos/shared-sdk/libs/emsp/src/clients/redux/back-office/invoice-v1.service';
import { baseApi } from '@service/base.api';

export const invoiceV1Api = injectInvoiceV1Api(baseApi);

export const {
  useGetInvoicesPaginatedQuery,
  useGetInvoiceQuery,
  useGetInvoicePdfMutation,
} = invoiceV1Api;
